import * as React from "react";
import { SVGProps, memo } from "react";

const SvgPharmacy = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={41} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.121 13.9a.2.2 0 0 1 .174-.1h28.087a.2.2 0 0 1 .179.11l4 8a.2.2 0 0 1-.179.29H1.723a.2.2 0 0 1-.173-.3l4.571-8Z"
      fill="#D0EAFB"
      stroke="#000"
      strokeWidth={1.6}
      strokeLinejoin="round"
    />

    <path fill="#E7F4FD" stroke="#000" strokeWidth={1.6} d="M4.8 22.2h30.4v17.4H4.8z" />

    <path fill="#D0EAFB" stroke="#000" strokeWidth={1.6} d="M11.8 27.8h16.4v11.8H11.8z" />

    <path fill="#D0EAFB" stroke="#000" strokeWidth={1.6} d="M11.8 27.8h8.4v11.8h-8.4z" />

    <circle cx={20.5} cy={9.5} r={8.7} fill="#F5FBFF" stroke="#000" strokeWidth={1.6} />

    <mask id="Pharmacy_svg__a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m19.754 4.67.032-.036c1.099-1.218 3.1-1.204 4.47.032 1.37 1.235 1.59 3.224.492 4.442l-2.858 3.17-2.48-2.237-2.482-2.237 2.826-3.134Z"
      />
    </mask>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m19.754 4.67.032-.036c1.099-1.218 3.1-1.204 4.47.032 1.37 1.235 1.59 3.224.492 4.442l-2.858 3.17-2.48-2.237-2.482-2.237 2.826-3.134Z"
      fill="#fff"
    />

    <path
      d="m19.754 4.67 1.188 1.071.01-.01.01-.011-1.208-1.05Zm4.994 4.438L23.56 8.037 22.49 9.225l1.188 1.071 1.072-1.188Zm0 0 1.189 1.072 1.072-1.188L25.82 7.92 24.75 9.108Zm-2.858 3.17-1.071 1.189 1.188 1.071 1.071-1.188-1.188-1.072Zm-2.48-2.237 1.07-1.188-1.07 1.188Zm-2.482-2.237L15.74 6.732l-1.072 1.189 1.189 1.071 1.071-1.188Zm4.034-2.084.012-.015-2.376-2.143-.05.058 2.414 2.1Zm.012-.015c.392-.434 1.361-.617 2.21.149l2.143-2.376c-1.89-1.706-4.924-1.918-6.729.084l2.377 2.143Zm2.21.149c.85.766.767 1.749.376 2.183l2.377 2.142c1.805-2.002 1.281-4.996-.61-6.701l-2.143 2.376Zm.493 4.442L25.82 7.92l-2.143 2.376Zm-.116-2.26-2.86 3.17 2.377 2.144 2.859-3.17-2.376-2.143Zm-.6 3.054-2.48-2.237-2.143 2.376 2.48 2.238 2.144-2.377Zm-2.48-2.237L18 6.616l-2.143 2.376 2.48 2.237 2.144-2.376Zm-2.365.022 2.826-3.134-2.376-2.143-2.826 3.134 2.376 2.143Z"
      fill="#2B323B"
      mask="url(#Pharmacy_svg__a)"
    />

    <mask id="Pharmacy_svg__b" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.54 13.774a3.457 3.457 0 0 1-.018.02c-1.098 1.219-3.1 1.204-4.47-.031-1.37-1.236-1.59-3.225-.492-4.443l2.486-2.756 2.48 2.237 2.482 2.237-2.468 2.736Z"
      />
    </mask>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.54 13.774a3.457 3.457 0 0 1-.018.02c-1.098 1.219-3.1 1.204-4.47-.031-1.37-1.236-1.59-3.225-.492-4.443l2.486-2.756 2.48 2.237 2.482 2.237-2.468 2.736Z"
      fill="#0F72BD"
    />

    <path
      d="m20.54 13.774-1.188-1.072-.005.007-.006.006 1.2 1.059ZM15.56 9.32l1.188 1.072 1.072-1.188-1.189-1.072L15.56 9.32Zm0 0L14.37 8.25 13.3 9.437l1.188 1.071L15.56 9.32Zm2.486-2.756 1.071-1.189-1.188-1.071-1.072 1.188 1.189 1.072Zm2.48 2.237-1.071 1.188 1.072-1.188Zm2.482 2.237 1.188 1.072 1.071-1.189L24.08 9.85l-1.072 1.188Zm-3.667 1.677a.307.307 0 0 1-.007.008l2.376 2.143.03-.033-2.399-2.118Zm-.007.008c-.392.434-1.36.617-2.21-.149l-2.143 2.377c1.89 1.705 4.924 1.917 6.73-.085l-2.377-2.143Zm-2.21-.149c-.85-.765-.767-1.748-.376-2.182l-2.376-2.143c-1.806 2.002-1.282 4.997.609 6.702l2.143-2.377Zm-.493-4.442-2.143 2.376 2.143-2.376Zm.117 2.26 2.486-2.757-2.377-2.143-2.486 2.757 2.377 2.143Zm.226-2.64 2.481 2.237 2.143-2.376-2.481-2.238-2.143 2.377Zm2.481 2.237 2.481 2.237 2.143-2.376-2.481-2.237-2.143 2.376Zm2.364-.022-2.467 2.735 2.377 2.143 2.467-2.736-2.377-2.142Z"
      fill="#2B323B"
      mask="url(#Pharmacy_svg__b)"
    />
  </svg>
);

const Memo = memo(SvgPharmacy);

export default Memo;
